$(document).ready(function() {
    $(document).on('click', '.js-paths-angel', function() {
        $("#mythic-paths").removeAttr('class');
        $("#mythic-paths").attr('class', 'b-paths angel right');
    });
    $(document).on('click', '.js-paths-lich', function() {
        $("#mythic-paths").removeAttr('class');
        $("#mythic-paths").attr('class', 'b-paths lich right');
    });
    $(document).on('click', '.js-paths-aeon', function() {
        $("#mythic-paths").removeAttr('class');
        $("#mythic-paths").attr('class', 'b-paths aeon right');
    });
    $(document).on('click', '.js-paths-azata', function() {
        $("#mythic-paths").removeAttr('class');
        $("#mythic-paths").attr('class', 'b-paths azata right');
    });
    $(document).on('click', '.js-paths-demon', function() {
        $("#mythic-paths").removeAttr('class');
        $("#mythic-paths").attr('class', 'b-paths demon right');
    });
    $(document).on('click', '.js-paths-dragon', function() {
        $("#mythic-paths").removeAttr('class');
        $("#mythic-paths").attr('class', 'b-paths dragon right');
    });
    $(document).on('click', '.js-paths-locust', function() {
        $("#mythic-paths").removeAttr('class');
        $("#mythic-paths").attr('class', 'b-paths locust right');
    });
    $(document).on('click', '.js-paths-trickster', function() {
        $("#mythic-paths").removeAttr('class');
        $("#mythic-paths").attr('class', 'b-paths trickster right');
    });
    $(document).on('click', '.js-paths-legend', function() {
        $("#mythic-paths").removeAttr('class');
        $("#mythic-paths").attr('class', 'b-paths legend right');
    });
    $(document).on('click', '.js-paths-devil', function() {
        $("#mythic-paths").removeAttr('class');
        $("#mythic-paths").attr('class', 'b-paths devil right');
    });
    $(document).on('click', '.js-paths-item', function() {
        $('.js-paths-item').removeClass('active');
        $(this).addClass('active');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/main/paths.js